import { FinancialCreditClientOrigin } from "@gipi-financial/credit-client/enums/credit-client-origin.enum";
import { FinancialCreditClientType } from "@gipi-financial/credit-client/enums/credit-client-type.enum";
import { GIPIAbstractDTO, GIPIUuid } from "@gipisistemas/ng-core";
import { FinancialCheckReceivedCreditClientDTO } from "./check-received-credit-client.dto";
import { FinancialReceivementCardCreditClientDTO } from "./receivement-card-credit-client.dto";

export class FinancialCreditClientDTO extends GIPIAbstractDTO {

    /** @Required Valor */
    amount: number;

    /** Id da conta bancária */
    bankAccountId: GIPIUuid;

    /** Id do turno do caixa */
    cashierShiftId: GIPIUuid;

    /** Id do tipo de cobrança */
    chargeTypeId: GIPIUuid;

    /** Lista de cheques recebidos */
    checkReceivedList: FinancialCheckReceivedCreditClientDTO[];

    /** @Required Id do cliente */
    clientId: GIPIUuid;

    /** @Required Data */
    date: Date;

    /** @Required Descrição - Observação */
    description: string;

    /** Número de documento */
    documentNumber: string;

    /** @Required Origem do lançamento */
    originLaunch: FinancialCreditClientOrigin;

    /** Id da categoria */
    postingCategoryId: GIPIUuid;

    /** Lista de recebimentos de cartão */
    receivementCardList: FinancialReceivementCardCreditClientDTO[];

    /** @Required Tipo do crédito - (`CREDIT`, `DEBIT`) */
    type: FinancialCreditClientType;

}
